import type { SessionCard, SessionTask } from '../type';
import { getCardById } from './get-card-by-id';
import { getTaskById } from './get-task-by-id';

export function getTaskByCardAndTaskId(
  cardId: SessionCard['id'],
  taskId: SessionTask['id'],
  cards: SessionCard[],
  caller: string,
): SessionTask | undefined {
  const card = getCardById(cardId, cards, caller);
  if (card !== undefined) {
    if (card.type !== 'start-with-error') {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return getTaskById(taskId, card.tasks!, caller);
    }

    return undefined;
  }

  return card;
}
